/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */
export type paths = {
    readonly '/api/auth/ldap': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** LDAP configuration */
        readonly get: operations['getLdapConfiguration']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/auth/mfa': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** MFA configuration */
        readonly get: operations['getMfaConfiguration']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/auth/msEntraId': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** MS Entra ID configuration */
        readonly get: operations['getMsEntraIdConfiguration']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/authenticate': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Validate authentication claim */
        readonly post: operations['authenticate']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/authorize': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Validate authorization claim */
        readonly post: operations['authorization']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/broker/auth/check-updates': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Change token of each given user, for the broker cache */
        readonly post: operations['checkUpdates']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/broker/auth/enhanced': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Enhanced authentication of MQTT5 (not supported) */
        readonly post: operations['enhancedBrokerAuth']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/broker/auth/publish': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Authorize on publish */
        readonly post: operations['publish']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/broker/auth/register': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Authenticate on connection */
        readonly post: operations['register']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/broker/auth/subscribe': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Authorize on subscribe */
        readonly post: operations['subscribe']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/broker/auth/subscribeMQTT5': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Authorize on subscribe with MQTT 5 properties */
        readonly post: operations['subscribeMQTT5']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/certificates': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List certificates */
        readonly get: operations['listCertificates']
        readonly put?: never
        /** Add certificate */
        readonly post: operations['addCertificate']
        /** Deletes certificate */
        readonly delete: operations['deleteCertificate']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/certificates/content': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Returns given certificate content */
        readonly get: operations['loadCertificateContent']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/client-registry': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Receive a list of all pending registration requests */
        readonly get: operations['getPendingRequests']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/client-registry/confirm': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Confirm a single authentication request */
        readonly post: operations['confirmRequest']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/client-registry/lock': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Lock the registration endpoint now. This will flush the internal request cache. */
        readonly post: operations['lockRegistrationEndpoint']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/client-registry/open': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Open the registration endpoint temporarily */
        readonly post: operations['openRegistrationEndpoint']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/client-registry/register': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Endpoint for self-registration of clients */
        readonly post: operations['requestAccess']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/client-registry/runners/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        readonly post?: never
        /** Delete specific resource runner */
        readonly delete: operations['deleteResourcesRunner']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/client-registry/status': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return the current lock status of the registration endpoint */
        readonly get: operations['getRegistrationEndpointStatus']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/healthz': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Meta endpoint that returns 200 if server is ready */
        readonly get: operations['healthz']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/listUsers': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List users */
        readonly get: operations['listUsersPage']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/login': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Login into the cybus connectware */
        readonly post: operations['login']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/logout': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Logout of the cybus connectware */
        readonly post: operations['logout']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/maintenance/db': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return a database maintenance status */
        readonly get: operations['maintenanceDb']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/maintenance/db/backup': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Download a database backup */
        readonly get: operations['maintenanceDbBackupDownload']
        readonly put?: never
        /** Start a database backup */
        readonly post: operations['maintenanceDbBackupStart']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/maintenance/db/restore': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Upload archive and start database restore */
        readonly post: operations['maintenanceDbUploadRestore']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/mfa/disable': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** User self de-registration from MFA */
        readonly post: operations['disableMfa']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/mfa/enable': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Enable MFA for an existing user */
        readonly post: operations['enableMfa']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/mfa/isenrolled': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Checks if a user is enrolled to mfa or not */
        readonly get: operations['isenrolled']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/mfa/login': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Login user with MFA */
        readonly post: operations['loginMfa']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/mfa/regenerate/backupcodes': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Regenarete backup codes a user */
        readonly post: operations['regenerateBackupcodes']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/mfa/validate': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Validate MFA enrollment of the user */
        readonly post: operations['validateEnrollment']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/msEntraId/login': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Redirects the client that accesses this path to the MS Entra ID login page */
        readonly get: operations['msEntraIdLogin']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/msEntraId/redirect': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Landing endpoint after user is done authenticating with MS Entra ID */
        readonly get: operations['msEntraIdRedirect']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/permissions': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return the permissions of the current user */
        readonly get: operations['getCurrentUserPermissions']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/permissions/ids': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return all permissions ids */
        readonly get: operations['getPermissionIds']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/permissions/page': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return a page of all permissions */
        readonly get: operations['getPermissionsPage']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/policy/password': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return a password policy rules */
        readonly get: operations['policyPassword']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/policy/username': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return a username policy rules */
        readonly get: operations['policyUsername']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/roles': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List roles */
        readonly get: operations['listRoles']
        readonly put?: never
        /** Create a new role */
        readonly post: operations['createRole']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/roles/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get a specific role */
        readonly get: operations['role']
        /** Update an existing role */
        readonly put: operations['updateRole']
        readonly post?: never
        /** Delete an existing role */
        readonly delete: operations['deleteRole']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/roles/+/permissions': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List role permissions */
        readonly get: operations['listRolePermissions']
        readonly put?: never
        /** Add a new permission to a role */
        readonly post: operations['createPermission']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/roles/+/permissions/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Update an existing permission */
        readonly get: operations['getPermission']
        /** Update an existing permission */
        readonly put: operations['updatePermission']
        readonly post?: never
        /** Delete an existing permission */
        readonly delete: operations['deletePermission']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/roles/names': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List roles names */
        readonly get: operations['listRoleNames']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/roles/page': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List paginated roles */
        readonly get: operations['listPaginatesRoles']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/session': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Return the session of the current user */
        readonly get: operations['getCurrentUserAuthentication']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Create a new user */
        readonly post: operations['createUser']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/+': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get a specific user */
        readonly get: operations['user']
        /** Update an existing user */
        readonly put: operations['updateUser']
        readonly post?: never
        /** Delete an existing user */
        readonly delete: operations['deleteUser']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/+/certificates': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Add a new certificate to a user */
        readonly post: operations['createCertificate']
        /** Delete an existing certificate */
        readonly delete: operations['deleteUserCertificate']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/+/roles': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Add a new role to a user */
        readonly post: operations['usercreateRole']
        /** Remove a role from a user */
        readonly delete: operations['deleteUserRole']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/+/tokens': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Get all tokens generated by this user */
        readonly get: operations['getUserTokens']
        readonly put?: never
        readonly post?: never
        /** Delete all tokens generated by this user */
        readonly delete: operations['deleteUserTokens']
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/batch': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Create new users in batch */
        readonly post: operations['createUsersBatch']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/batch/delete': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        readonly put?: never
        /** Delete users in batch */
        readonly post: operations['deleteUsersBatch']
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/change-password': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get?: never
        /** Change user password */
        readonly put: operations['changeUserPassword']
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/ids': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List user ids */
        readonly get: operations['listUserIds']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/users/usernames': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** List all usernames */
        readonly get: operations['listUsernames']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v1/certs/list/approved': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        /** Current list of approved certificates/principals */
        readonly get: operations['envoyTls']
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
}
export type components = {
    schemas: {
        readonly AuthenticatePostRequest: {
            readonly certificate?: string
            readonly password?: string
            readonly token?: string
            readonly userId?: string
            readonly userName?: string
        }
        readonly AuthenticateResponse: {
            readonly isAuthenticated: boolean
            readonly userId: string
        }
        readonly AuthorizedResponse: {
            readonly isAuthorized: boolean
        }
        readonly AuthorizePostRequest: {
            readonly context: components['schemas']['Context']
            readonly operation: components['schemas']['Operation']
            readonly resource: string
            readonly userId: string
            readonly userName?: string
        }
        readonly AuthRequestsResponse: readonly {
            /**
             * @description Free text that helps the granting user understanding where this request comes from.
             * @example IoT Device Serial Number <0123456>
             */
            readonly context: string
            /** @enum {string} */
            readonly credentialType: 'certificate' | 'password'
            readonly granted: boolean
            readonly permissions: readonly components['schemas']['PermissionPostRequest'][]
            readonly roles: readonly string[]
            /**
             * @description String with ISO 8601 timestamp of the last request update.
             * @example 2022-03-25T17:25:21.379Z
             */
            readonly timestamp: string
            /**
             * @description Username that is requested to be granted access.
             * @example iot.device.0123456
             */
            readonly username: string
        }[]
        readonly Certificate: {
            readonly createdAt?: string
            readonly expiresAt?: string
            readonly fingerprint?: string
        }
        readonly CertificateDeleteRequest: {
            readonly fingerprint: string
        }
        readonly CertificatePostRequest: {
            readonly fingerprint: string
        }
        readonly ClientRegistryPolicyViolationResponse: {
            /** @description Define on which property is a policy failure. 0 is a username, 1 is a password. */
            readonly code: number
            /** @description Provides details of the violated rules. */
            readonly details?: {
                /** @description It provides details about the required number of lower-case letters. */
                readonly lower?: components['schemas']['PasswordPolicyViolationDetailsRule']
                /** @description It provides details about the minimum password length policy requirement. */
                readonly min?: components['schemas']['PasswordPolicyViolationDetailsRule']
                /** @description It provides details about the required number of numeric characters. */
                readonly numeric?: components['schemas']['PasswordPolicyViolationDetailsRule']
                /** @description It provides details about the required number of symbols/punctuations. */
                readonly symbol?: components['schemas']['PasswordPolicyViolationDetailsRule']
                /** @description It provides details about the required number of upper-case letters. */
                readonly upper?: components['schemas']['PasswordPolicyViolationDetailsRule']
                /** @description It contains the username that breaks the rule. */
                readonly username?: string
            }
            /** @description A policy failure description. */
            readonly message: string
        }
        readonly ClientRegistryPositiveResponse: {
            /**
             * @description Signed certificate in Base64 encoded PEM format. This is only supplied if a CSR had been present in the registration payload.
             * @example LS0tLS1CRUdJTiBDRVJUSUZJQ0FURS0tLS0tCk1JSUVyVENDQXBXZ0F3SUJBZ0lVS0pYWUpZNWdK
             *     NExMbHpvSlcvUi9iczMxakw0d0RRWUpLb1pJaHZjTkFRRUYKQlFBd2dZMHhFekFSQmdOVkJBb01D
             *     a041WW5WeklFZHRZa2d4RkRBU0JnTlZCQXNNQzBSbGRtVnNiM0J0Wlc1MApNUjB3R3dZSktvWklo
             *     dmNOQVFrQkZnNW9aV3hzYjBCamVXSjFjeTVwYnpFUU1BNEdBMVVFQnd3SFNHRnRZblZ5Clp6RVFN
             *     QTRHQTFVRUNBd0hTR0Z0WW5WeVp6RUxNQWtHQTFVRUJoTUNSRVV4RURBT0JnTlZCQU1NQjBONVlu
             *     VnoKUTBFd0hoY05Nakl3TlRFMk1URXlNVFU1V2hjTk1qTXdOVEUyTVRFeU1UVTVXakJ2TVFzd0NR
             *     WURWUVFHRXdKRQpSVEVQTUEwR0ExVUVDQXdHUW1WeWJHbHVNUlF3RWdZRFZRUUtEQXRTYjJKdmRI
             *     TWdTVzVqTGpFTU1Bb0dBMVVFCkN3d0RVaVpFTVEwd0N3WURWUVFEREFSU01rUXlNUnd3R2dZSktv
             *     WklodmNOQVFrQkZnMXlNbVF5UUdONVluVnoKTG1sdk1JSUJJakFOQmdrcWhraUc5dzBCQVFFRkFB
             *     T0NBUThBTUlJQkNnS0NBUUVBd2pLVUdMeVRVZDNhWEVOWgozREx0WEJuSCtJaVM2TkpBU1ptQjF3
             *     R1BvMy9McEloc3R6UzFsLzVzVmdWaUNPM3kwUkFFNGJ3ektqRnQvUUQ3Cnc0WVoxR2hiSy9HcWF2
             *     OUwvd3lSVVZDdHNxQ2ZUUmw2UzZKZ0E5UHhMODRCaFhJVTZhUmlSVW1iUzhPbloxMnEKMXN3VmVh
             *     Kzd5V0JXNDZzQ25RUHczc0NwZlJsVFN3U0RoOVVhSU1xQW8zaW9BT3EzQ0pVbWdhVVlFRnFOL1BU
             *     VQpsY05uR0k4Um15bGNkdXVKWGlCR2hZUWROd1dxRHl2bGY1Z1AyTXQ0VzFaQ2dmMGVudDBBNXhn
             *     RVVwUVJWeGowClh1YjhSOTFNK25yZUNidEMxUEVvRC9OSGJ6aFVBUUhvU1gvVkpvSFEzRnRTbVhI
             *     ZFBQRTU4bHZhSzBhMHBPenQKVHBHckJRSURBUUFCb3lJd0lEQUpCZ05WSFJNRUFqQUFNQk1HQTFV
             *     ZEpRUU1NQW9HQ0NzR0FRVUZCd01DTUEwRwpDU3FHU0liM0RRRUJCUVVBQTRJQ0FRQmpkWGtBaUtJ
             *     WUd0Q3RIMDVwck1hbWhZSHl3cFNYdzBPSzB4bTBMcFlTCkpvc094OWFGVjRqcS9Fb3NlWlZndkR0
             *     OGM0ajlXVlBkQ1lmOHlwaHVFRS8yM2s3akEzaFlYZmFIZnVoenZnaWgKSDB3U0Q2WmgrNGptaDdE
             *     V0tEVnRwOWI4aFBmdytzR3ltYUtkaWM4WFNVMlNDK1RMNGRYTkFlTjFIeVVtanltcApRZFZBamsx
             *     QXNRT3YvU0gzaEg4cmJBWEprMWpoTks0Z2tGT0oxTHJ5TkR3dmNPc3JHbFpLY3BsWStKVE1HZkFH
             *     CjUyYmFtdGpIVG9FQ1BSOGhIeGx6bTlFYUxidUtpUlpwZ242M25qYWRWK1d4a09zVTlPSUM3dm9U
             *     SlNtQ3VOZmkKdjh1RmdsSUFGS0JXSmVOZERxQk5OZnBjTU5GTDV0R1NIbzkvVEtLQ3hEam1QN3Ns
             *     c3BRMzVYTFluODl1MjY3agpJZmU2dkppdXZxdXdyN0c1S1orTTkvQitlWk5ISHVrNEFDTUs5OFk1
             *     cWhtb2pQS3p5Z202b2FiRzI3bk1EYzF5CkM0Q05LUWUrL1J5SEdYbXFjdm5ZVGxHVGpNWktoRWpX
             *     OVp3UmJyZVZ1M1lmNVhlZU95OXNpOWs5VTI3bVQ0UTUKdC8zU2xCK2JiTW4vbzVPWFI0YStnT2VX
             *     VWVJRzl6SzNvYVdXbmVKVlZPdmRlQy8xTjY0ajRERjlKWm45cGtENgowdUozQUFKMUYvN2tJa2tT
             *     MXNmZWdjejZCU2pkMldkQjhHaDZSN1ZVS0VPSEpCREphZm1EdkRjVGdSZytQa1NUCmpjdHVzVnNl
             *     Yi9lcE1BRkQ1dERuUDFHVU8yYkx2dzQ3QWl0akxKdnljeUZZbnovU1ZFK2dXOTU3ZEpXcVVjZEkK
             *     YXc9PQotLS0tLUVORCBDRVJUSUZJQ0FURS0tLS0tCgo=
             */
            readonly certificate?: string
        }
        readonly ClientRegistryRequest: {
            /**
             * @description Free text that helps the granting user understanding where this request comes from.
             * @example IoT Device Serial Number <0123456>
             */
            readonly context: string
            /**
             * @description Base 64 encoded certificate signing request in PEM format. Instead of a password, a client side certificate (x.509) can be used for authentication. If the CSR is supplied, the signed certificate will be returned once the authentication request is granted.
             * @example LS0tLS1CRUdJTiBDRVJUSUZJQ0FURSBSRVFVRVNULS0tLS0KTUlJQ3REQ0NBWndDQVFBd2J6RUxN
             *     QWtHQTFVRUJoTUNSRVV4RHpBTkJnTlZCQWdNQmtKbGNteHBiakVVTUJJRwpBMVVFQ2d3TFVtOWli
             *     M1J6SUVsdVl5NHhEREFLQmdOVkJBc01BMUltUkRFTk1Bc0dBMVVFQXd3RVVqSkVNakVjCk1Cb0dD
             *     U3FHU0liM0RRRUpBUllOY2pKa01rQmplV0oxY3k1cGJ6Q0NBU0l3RFFZSktvWklodmNOQVFFQkJR
             *     QUQKZ2dFUEFEQ0NBUW9DZ2dFQkFNSXlsQmk4azFIZDJseERXZHd5N1Z3WngvaUlrdWpTUUVtWmdk
             *     Y0JqNk4veTZTSQpiTGMwdFpmK2JGWUZZZ2p0OHRFUUJPRzhNeW94YmYwQSs4T0dHZFJvV3l2eHFt
             *     ci9TLzhNa1ZGUXJiS2duMDBaCmVrdWlZQVBUOFMvT0FZVnlGT21rWWtWSm0wdkRwMmRkcXRiTUZY
             *     bXZ1OGxnVnVPckFwMEQ4TjdBcVgwWlUwc0UKZzRmVkdpREtnS040cUFEcXR3aVZKb0dsR0JCYWpm
             *     ejAxSlhEWnhpUEVac3BYSGJyaVY0Z1JvV0VIVGNGcWc4cgo1WCtZRDlqTGVGdFdRb0g5SHA3ZEFP
             *     Y1lCRktVRVZjWTlGN20vRWZkVFBwNjNnbTdRdFR4S0EvelIyODRWQUVCCjZFbC8xU2FCME54YlVw
             *     bHgzVHp4T2ZKYjJpdEd0S1RzN1U2UnF3VUNBd0VBQWFBQU1BMEdDU3FHU0liM0RRRUIKQ3dVQUE0
             *     SUJBUUIxejdKcGRIRERScTl2WE1BMmNBVVZBRmYvYkRXNzlkNmlMQ0pDVDZ5WlhOcHV0ZXA3N1pQ
             *     dQpIMSszb08vZmRJdDhaOThjV0J4ZVBNckVDM2krQ0lIdms4a202SVFMVW05cUZVdHRDN0VjUmpU
             *     UFYwT29vb2l0ClhXOHhzWVhGaEZPTStydTJnbEcrSUVMY3BydS9JamxyVHpwaUtNZVJGQ1FFemww
             *     WWtZRDZkSk82ME1CRVhjZUgKWHpFZTRtT2oxUDJKNFcycFI1bDFsQjZ5dXB4SWVuRjRhNm5EeFFE
             *     eFZkcmtBTHNJdDhGZUNTNDNvaHg4NVQ5SApHN2IwOFdmdEFrYzhKR3ZLb00rdE90MzlVZFFESE1S
             *     OU5QOG9RUUpMaldMcWZRdUtaRmZXNVJyR24zSzA2UGNICkRMN1FNc1hxNFBaMyswUXpCSjZJVGoz
             *     aUZubHp1VXBqCi0tLS0tRU5EIENFUlRJRklDQVRFIFJFUVVFU1QtLS0tLQo=
             */
            readonly csr?: string
            /**
             * @description Secret password that should be set for the user. This will be stored in hashed form on the receiver side. Either this or a csr should be supplied.
             * @example secret-password
             */
            readonly password?: string
            /** @description Permissions the user wants to be granted individually */
            readonly permissions?: readonly components['schemas']['PermissionPostRequest'][]
            /** @description Name of roles the user wants to be assigned to */
            readonly roles?: readonly string[]
            /**
             * @description Username to be registered. The Auth Server will check this for uniqueness, so be sure to generate a reasonably namespaced username.
             * @example iot.device.0123456
             */
            readonly username: string
        }
        readonly ConfirmRegistrationRequest: {
            readonly grantTypes?: readonly components['schemas']['GrantType'][]
            readonly initialPermissions?: readonly components['schemas']['PermissionPostRequest'][]
            readonly mqttPublishPrefix?: string
            /** @description An array of roleId of the roles the new user should have. (Must be roleId, not role name.) */
            readonly roles?: readonly string[]
            /** @description Username to confirm. Must match a username that is currently in the pendingRequests list. */
            readonly username: string
        }
        /** @enum {string} */
        readonly Context: 'http' | 'mqtt' | 'control_plane'
        readonly CybusCertificate: {
            readonly basicConstraints: {
                /** @description CA flag of the basicConstraints extension, false if absent. */
                readonly isCA: boolean
                /**
                 * Format: int32
                 * @description Path length constraint, -1 if not set.
                 */
                readonly pathLength: number
            }
            /**
             * Format: int64
             * @description End of validity, milliseconds since the Unix epoch.
             */
            readonly expiresOn: number
            /** @description Property names of the parsed extKeyUsage extension (`oid`, `critical`, `value`, `name` and one entry per purpose: name such as `serverAuth`, or the dotted OID if unknown); empty if absent. */
            readonly extendedKeyUsage: readonly string[]
            /** @description Hex-encoded fingerprints of the certificate's public key. */
            readonly fingerprints: {
                readonly sha1: string
                readonly sha256: string
            }
            /** @description Stable identifier: hex-encoded SHA-256 fingerprint of the certificate's public key, equal to `fingerprints.sha256`. */
            readonly id: string
            /** @description Selected issuer DN attributes (first value each); missing ones are empty strings. */
            readonly issuedBy: {
                readonly commonName: string
                readonly organization: string
                readonly organizationalUnit: string
            }
            /**
             * Format: int64
             * @description Start of validity, milliseconds since the Unix epoch.
             */
            readonly issuedOn: number
            /** @description Selected subject DN attributes (first value each); missing ones are empty strings. */
            readonly issuedTo: {
                /** @description Names from the subjectAltName extension, empty if the extension is absent. */
                readonly alternativeNames: readonly string[]
                readonly commonName: string
                readonly organization: string
                readonly organizationalUnit: string
            }
            /** @description Property names of the parsed keyUsage extension (`oid`, `critical`, `value`, `name`, `keyUsage` and all nine usage flags, set or not); empty if absent. */
            readonly keyUsage: readonly string[]
            /** @description false if deletion is refused (403): only stored certificate, issued by another stored certificate, or the server certificate. */
            readonly removable: boolean
        }
        /** @description No fields are present in this response body (an empty JSON object). */
        readonly EmptyResponse: Record<string, never>
        readonly EnvoyGetResponse: {
            readonly certificates?: readonly {
                readonly fingerprint_sha256?: string
            }[]
        }
        /** @description Generic error body. */
        readonly ErrorResponse: {
            /** @description The error code */
            readonly code?: string
            /** @description A human readable description of the error, may be empty */
            readonly message?: string
        }
        readonly GrantType: {
            readonly isRequired?: boolean
            readonly method?: components['schemas']['Method']
        }
        /** @enum {string} */
        readonly IdentityProvider: 'local' | 'ldap' | 'msentraid'
        readonly InvalidOTPResponse: {
            readonly banDurationMinutes?: number
            readonly count?: number
            readonly error?: string
            readonly msg?: string
            readonly triesLeft?: number
        }
        readonly IsEnrolledResponse: {
            readonly isEnrolled: boolean
        }
        readonly LdapResponse: {
            /** @default false */
            readonly enabled: boolean
            /** @default GROUP */
            readonly mode: string
        }
        readonly LoginRequest: {
            readonly expireTimeInHours?: number
            readonly label?: string
            readonly password: string
            readonly username: string
        }
        readonly LoginResponse:
            & ({
                /**
                 * @description Present when MFA was enrolled by the user already
                 * @enum {boolean}
                 */
                readonly needsMfa: true
                readonly secret: string
            } | {
                readonly token: string
            })
            & {
                /** Format: date-time */
                readonly expiresAt: string
            }
            & (
                | ({
                    /**
                     * @description Present when MFA has to be enrolled but was not enrolled by the user
                     * @enum {boolean}
                     */
                    readonly enforceMFAEnrollment: true
                    /** @description Permissions the authenticated user has */
                    readonly permissions: readonly components['schemas']['Permission'][]
                } | Record<string, never>)
                | {
                    /** @description Permissions the authenticated user has */
                    readonly permissions: readonly components['schemas']['Permission'][]
                }
            )
        readonly LogoutRequest: {
            readonly token: string
        }
        readonly MaintenanceDb: {
            readonly backup?: components['schemas']['MaintenanceDbStatus']
            readonly restore?: components['schemas']['MaintenanceDbStatus']
            /** @description Indicate the current running status of a backup/restore operation. */
            readonly running?: boolean
        }
        readonly MaintenanceDbStatus: {
            /**
             * Format: date-time
             * @description End date and time of a last backup/restore operation.
             */
            readonly endDate?: string
            /** @description The backup/restore id */
            readonly id?: string
            /**
             * Format: date-time
             * @description Start date and time of a last backup/restore operation.
             */
            readonly startDate?: string
            /** @description Describe the reason for the failure, if any */
            readonly statusMessage?: string
            /** @description Indicate the failure status from the last backup/restore operation. */
            readonly succeeded?: boolean
        }
        /** @enum {string} */
        readonly Method: 'password' | 'token' | 'certificate'
        readonly MfaDisablePostRequest: {
            readonly backupCode?: string
            readonly otp?: string
        }
        readonly MfaEnableResponse: {
            /** @example otpauth://totp/Cybus:Connectware?issuer=Cybus&secret=something&algorithm=SHA1&digits=6&period=30 */
            readonly uri: string
        }
        readonly MfaLoginPostRequest: {
            readonly backupCode?: string
            readonly otp?: string
            readonly secret: string
            readonly username: string
        }
        readonly MFALoginResponse: {
            readonly expiresAt: string
            /** @description Permissions the authenticated user has */
            readonly permissions: readonly components['schemas']['Permission'][]
            readonly token: string
        }
        readonly MfaRegeneratePostRequest: {
            readonly backupCode?: string
            readonly otp?: string
        }
        readonly MfaResponse: {
            /** @default false */
            readonly enabled: boolean
        }
        readonly MfaValidatePostRequest: {
            readonly otp: string
        }
        readonly MfaValidateResponse: {
            readonly backupCodes: readonly string[]
        }
        /** @description Every username cached on the calling broker node, in one request, with no upper bound. */
        readonly MQTTCheckUpdatesRequest: readonly {
            readonly username: string
        }[]
        /** @description One entry per resolved username. A requested username that resolves to no user is omitted entirely, which is how a deleted user is signalled. */
        readonly MQTTCheckUpdatesResponse: readonly {
            /**
             * Format: int64
             * @description Change token of the user, epoch milliseconds
             */
            readonly updatedAt: number
            readonly username: string
        }[]
        readonly MQTTEnhancedRequest: {
            readonly client_id?: string
            readonly properties?: {
                readonly p_authentication_method?: string
            }
        }
        readonly MQTTPublishRequest: {
            readonly client_id?: string
            readonly mountpoint?: string
            readonly payload?: string
            readonly qos?: number
            readonly retain?: boolean
            readonly topic?: string
            readonly username?: string
        }
        readonly MQTTRegisterRequest: {
            readonly clean_session?: boolean
            readonly client_id?: string
            readonly mountpoint?: string
            readonly peer_addr?: string
            readonly peer_port?: number
        }
        readonly MQTTResponse: {
            readonly modifiers?: {
                readonly max_inflight_messages?: string
                readonly max_message_size?: string
                readonly retry_interval?: string
            }
            readonly result?: string
            /**
             * Format: int64
             * @description Change token of the user, epoch milliseconds. Optional: present only when the decision succeeded, and absent when it was denied or the user is unknown.
             */
            readonly updatedAt?: number
        }
        readonly MQTTSubscribeRequest: {
            readonly mountpoint?: string
            readonly topics?: readonly {
                readonly qos?: number
                readonly topic?: string
            }[]
            readonly username?: string
        }
        readonly MQTTSubscribeResponse: {
            readonly result?: string
            readonly topics?: readonly {
                readonly qos?: number
                readonly topic?: string
            }[]
            /**
             * Format: int64
             * @description Change token of the user, epoch milliseconds. Optional: present only when the decision succeeded, and absent when it was denied or the user is unknown.
             */
            readonly updatedAt?: number
        }
        readonly MQTTSubscribeV5Response: {
            readonly modifiers?: {
                readonly topics?: readonly {
                    readonly qos?: number
                    readonly topic?: string
                }[]
            }
            readonly result?: string
            /**
             * Format: int64
             * @description Change token of the user, epoch milliseconds. Optional: present only when the decision succeeded, and absent when it was denied or the user is unknown.
             */
            readonly updatedAt?: number
        }
        readonly MsEntraIdResponse: {
            /** @default false */
            readonly enabled: boolean
        }
        readonly NewUserIds: readonly string[]
        readonly OpenRegistrationEndpointRequest: {
            /**
             * @description This parameter defines how long the registration endpoint will be kept open (in milliseconds). Default if undefined: 30000 milliseconds
             * @example 30000
             */
            readonly duration?: number
        }
        /** @enum {string} */
        readonly Operation: 'read' | 'write' | 'readWrite'
        readonly PaginatedRole: {
            readonly autogenerated?: boolean
            readonly id?: string
            readonly isshared?: boolean
            readonly ldapgroupdn?: string
            /** @description A comma separated list of MS Entra Id groups associated with this role */
            readonly msEntraIdGroupIds?: string
            readonly name?: string
            readonly permissions?: readonly {
                /** @description Context of the permission */
                readonly context?: unknown
                /** @description Id of the permission */
                readonly id?: unknown
                /** @description Operation of the permission */
                readonly operation?: unknown
                /** @description Resource of the permission */
                readonly resource?: unknown
            }[]
            /** @description The array will always have at least one element, will null values if there are no users */
            readonly users?: readonly {
                /** @description The id of the usern */
                readonly id?: unknown
                /** @description The username of the user */
                readonly username?: unknown
            }[]
        }
        readonly PaginatedUsers: {
            readonly pagination?: components['schemas']['Pagination']
            readonly users?: readonly components['schemas']['User'][]
        }
        readonly Pagination: {
            /** @description Returned page number */
            readonly currentPage?: number
            /** @description The next page */
            readonly nextPage?: number
            /** @description The number of rows per page requested by the client */
            readonly rowsPerPage?: number
            /** @description Number of pages available */
            readonly totalPages?: number
            /** @description Total number of rows available */
            readonly totalRows?: number
            /** @description Total number of rows for the selected page */
            readonly totalRowsInPage?: number
        }
        readonly PasswordPolicy: {
            /** @description The minimum number of lower-case letters a password must contain. Zero disables this rule. */
            readonly lower?: number
            /** @description The minimum number of characters a password must contain. Zero disables this rule. */
            readonly min?: number
            /** @description The minimum number of digit numbers a password must contain. Zero disables this rule. */
            readonly numeric?: number
            /** @description The minimum number of symbol or punctuation characters a password must contain. Zero disables this rule. */
            readonly symbol?: number
            /** @description The minimum number of upper-case letters a password must contain. Zero disables this rule. */
            readonly upper?: number
        }
        /** @description It provides a password policy rule violation details */
        readonly PasswordPolicyViolationDetailsRule: {
            /** @description A current number for a particular rule (number of chars or length). */
            readonly current?: number
            /** @description A violation message. */
            readonly message?: string
            /** @description A required number for a particular rule (number of chars or length). */
            readonly required?: number
        }
        readonly Permission: {
            readonly context?: components['schemas']['Context']
            readonly id?: string
            readonly operation?: components['schemas']['Operation']
            /** @description The MQTT topic or REST URL path for which the permission is granted. Both may include MQTT-style wildcards. */
            readonly resource?: string
        }
        readonly PermissionIndex: {
            readonly context?: components['schemas']['Context']
            /** @description The ids that have the same aformentioned resource, operation and context */
            readonly ids?: readonly string[]
            readonly operation?: components['schemas']['Operation']
            /** @description The permission's resource */
            readonly resource?: string
        }
        readonly PermissionPostRequest: {
            readonly context: components['schemas']['Context']
            readonly operation: components['schemas']['Operation']
            readonly resource: string
        }
        readonly PermissionPutRequest: {
            readonly operation: components['schemas']['Operation']
            readonly resource?: string
        }
        readonly PermissionWithUsage: {
            readonly context?: components['schemas']['Context']
            /** @description The permission's resource */
            readonly resource?: string
            readonly usage?: readonly {
                /** @description If the role is shared or not */
                readonly isRoleShared?: string
                readonly operation?: components['schemas']['Operation']
                /** @description Role id of the role that has this permission */
                readonly roleId?: string
                /** @description Role name of the role that has this permission */
                readonly roleName?: string
                /** @description The user of the permission */
                readonly userId?: unknown
                /** @description Username of the user that has this permission, if there is only a role  */
                readonly username?: unknown
            }[]
        }
        readonly RegenerateResponse: {
            readonly backupCodes: readonly string[]
        }
        readonly RegistrationEndpointStatusResponse: {
            /** @enum {string} */
            readonly status: 'open' | 'locked'
            readonly unlockedUntil?: number
        }
        readonly Role: {
            readonly id?: string
            readonly isShared?: boolean
            readonly ldapGroupDn?: string
            /** @description A comma separated list of MS Entra Id groups associated with this role */
            readonly msEntraIdGroupId?: string
            readonly name?: string
            readonly permissions?: readonly components['schemas']['Permission'][]
        }
        readonly RoleIndex: {
            readonly id?: string
            readonly name?: string
        }
        readonly RolePostRequest: {
            readonly autoGenerated?: boolean
            readonly isShared: boolean
            readonly ldapGroupDn?: string
            /** @description A comma separated list of MS Entra Id groups associated with this role */
            readonly msEntraIdGroupIds?: string
            readonly name: string
            readonly permissions?: readonly components['schemas']['Permission'][]
        }
        readonly RolePutRequest: {
            readonly isShared?: boolean
            readonly ldapGroupDn?: string
            /** @description A comma separated list of MS Entra Id groups associated with this role */
            readonly msEntraIdGroupIds?: string
            readonly name: string
            readonly permissions?: readonly components['schemas']['Permission'][]
        }
        readonly SessionResponse: {
            readonly expiresAt?: string
            readonly mfa?: {
                readonly enabled?: boolean
                readonly enforced?: boolean
            }
            /** @description Permissions the authenticated user has */
            readonly permissions?: readonly components['schemas']['Permission'][]
            readonly username?: string
        }
        readonly Token: {
            readonly createdAt?: string
            readonly expiresAt?: string
            readonly fingerprint?: string
            readonly label?: string
        }
        readonly User: {
            readonly autoGenerated?: boolean
            readonly certificates?: readonly components['schemas']['Certificate'][]
            readonly enforceMFAEnrollment?: boolean
            readonly grantTypes?: readonly components['schemas']['GrantType'][]
            readonly id?: string
            readonly identityProvider?: components['schemas']['IdentityProvider']
            readonly mfa_is_enrolled?: boolean
            readonly mqttPublishPrefix?: string
            readonly roles?: readonly components['schemas']['Role'][]
            readonly tokens?: readonly components['schemas']['Token'][]
            readonly username?: string
        }
        readonly UserBannedResponse: {
            readonly error?: string
            readonly minutesUntilBanEnd?: number
            readonly msg?: string
        }
        readonly UserChangePasswordRequest: {
            readonly newPassword?: string
            readonly password?: string
        }
        readonly UserIndex: {
            readonly id?: string
            readonly username?: string
        }
        readonly UsernamePolicy: {
            /** @description The minimum number of characters a username must contain. Zero disables this rule. */
            readonly min?: number
        }
        readonly UserPostRequest: {
            /** @default false */
            readonly autoGenerated: boolean
            readonly certificates?: readonly components['schemas']['Certificate'][]
            /** @default false */
            readonly enforceMFAEnrollment: boolean
            readonly grantTypes: readonly components['schemas']['GrantType'][]
            readonly identityProvider: components['schemas']['IdentityProvider']
            readonly initialPermissions?: readonly components['schemas']['Permission'][]
            readonly mqttPublishPrefix?: string
            readonly password?: string
            /** @description An array of roleId of the roles the new user should have. (Must be roleId, not role name.) */
            readonly roles?: readonly string[]
            readonly username: string
        }
        readonly UserPutRequest: {
            /** @description Indicates that MFA for the given user should be disabled */
            readonly disableMfa?: boolean
            /** @description Enforces the user to enroll MFA */
            readonly enforceMFAEnrollment?: boolean
            readonly grantTypes?: readonly components['schemas']['GrantType'][]
            readonly identityProvider?: components['schemas']['IdentityProvider']
            readonly mqttPublishPrefix?: string
            readonly password?: string
            readonly permissions?: readonly components['schemas']['Permission'][]
            /** @description An array of roleId of the roles the new user should have. (Must be roleId, not role name.) */
            readonly roles?: readonly string[]
            readonly username?: string
        }
        readonly UserRoleDeleteRequest: {
            readonly roleId: string
        }
        readonly UserRolePostRequest: {
            readonly roleId: string
        }
    }
    responses: never
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}

interface operations {
    readonly getLdapConfiguration: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description LDAP configuration */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['LdapResponse']
                }
            }
        }
    }
    readonly getMfaConfiguration: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description MFA configuration */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MfaResponse']
                }
            }
            /** @description Forbidden access */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Network error */
            readonly 503: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getMsEntraIdConfiguration: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description MS Entra ID configuration */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MsEntraIdResponse']
                }
            }
        }
    }
    readonly authenticate: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Authentication claim to be validated */
                readonly 'application/json': components['schemas']['AuthenticatePostRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['AuthenticateResponse']
                }
            }
        }
    }
    readonly authorization: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Authorization claim to be validated */
                readonly 'application/json': components['schemas']['AuthorizePostRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['AuthorizedResponse']
                }
            }
        }
    }
    readonly checkUpdates: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description The usernames the broker currently holds in its cache */
                readonly 'application/json': components['schemas']['MQTTCheckUpdatesRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MQTTCheckUpdatesResponse']
                }
            }
        }
    }
    readonly enhancedBrokerAuth: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Not supported */
                readonly 'application/json': components['schemas']['MQTTEnhancedRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MQTTResponse']
                }
            }
        }
    }
    readonly publish: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description MQTT user, topic and options to authorize */
                readonly 'application/json': components['schemas']['MQTTPublishRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MQTTResponse']
                }
            }
        }
    }
    readonly register: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description MQTT user and connection options to authenticate and authorize */
                readonly 'application/json': components['schemas']['MQTTRegisterRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MQTTResponse']
                }
            }
        }
    }
    readonly subscribe: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description MQTT user, topics and options to authorize */
                readonly 'application/json': components['schemas']['MQTTSubscribeRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MQTTSubscribeResponse']
                }
            }
        }
    }
    readonly subscribeMQTT5: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description MQTT user, topics and options to authorize */
                readonly 'application/json': components['schemas']['MQTTSubscribeRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MQTTSubscribeV5Response']
                }
            }
        }
    }
    readonly listCertificates: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of all stored certificates */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['CybusCertificate'][]
                }
            }
            /** @description Error reading certificates */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly addCertificate: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Certificate content to be added, a chain can be passed and will be accepted */
                readonly 'application/json': string
            }
        }
        readonly responses: {
            /** @description Array of the certificates added from the request body */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['CybusCertificate'][]
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteCertificate: {
        readonly parameters: {
            readonly query: {
                /** @description Id of certificate */
                readonly id: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Certificate not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Error while attempting to delete Certificate */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly loadCertificateContent: {
        readonly parameters: {
            readonly query: {
                /** @description Id of certificate */
                readonly id: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Certificate content */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': string
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Certificate not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Error while attempting to delete Certificate */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getPendingRequests: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['AuthRequestsResponse']
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
        }
    }
    readonly confirmRequest: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                readonly 'application/json': components['schemas']['ConfirmRegistrationRequest']
            }
        }
        readonly responses: {
            /** @description OK. The request was confirmed. No response body is returned. */
            readonly 204: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description The request body is invalid, or one or more permissions are invalid. code is "InvalidContent" or "BadRequest". */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description No pending registration request for the given username, or one of the requested roles does not exist */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description The registration request for this username has already been confirmed. code is "Conflict". */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description The stored registration data could not be processed. code is "InvalidCSR", "CSRCommonNameMismatch", or "InternalServer" for anything else. */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
        }
    }
    readonly lockRegistrationEndpoint: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 204: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly openRegistrationEndpoint: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                readonly 'application/json': components['schemas']['OpenRegistrationEndpointRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 204: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly requestAccess: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                readonly 'application/json': components['schemas']['ClientRegistryRequest']
            }
        }
        readonly responses: {
            /** @description Granted. The registration request has been confirmed, proceed to login */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ClientRegistryPositiveResponse']
                }
            }
            /** @description Pending. The registration request has been accepted but needs to be confirmed. Try again later. */
            readonly 202: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid Request. */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Conflict. Might indicate that a conflicting registration is pending or a conflicting user is already existing. */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Policy violation. A user name or a password doesn't fulfill some of the policy rules. */
            readonly 422: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ClientRegistryPolicyViolationResponse']
                }
            }
            /** @description Locked. The registration endpoint is currently not open. Try again later. */
            readonly 423: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteResourcesRunner: {
        readonly parameters: {
            readonly query: {
                /** @description Id of resource runner */
                readonly id: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description The Resource Runner is a built-in Resource Runner of the platform, those can never be deleted. code is "BadRequest". */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description The Resource Runner has a recent heartbeat, so its Agent is still running and must be stopped before the Resource Runner can be deleted. code is "Conflict". */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Internal Server Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getRegistrationEndpointStatus: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['RegistrationEndpointStatusResponse']
                }
            }
        }
    }
    readonly healthz: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly listUsersPage: {
        readonly parameters: {
            readonly query?: {
                /** @description If the auto generated roles should be excluded from the results */
                readonly excludeAutoGenerated?: boolean
                /** @description The page number to fetch, starts at page 1 */
                readonly pageNumber?: number
                /** @description The number of records per page to return */
                readonly rowsPerPage?: number
                /** @description The optional list to be matched against the usernames */
                readonly usernameEq?: readonly string[]
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Object with array of users and pagination information */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['PaginatedUsers']
                }
            }
            /** @description Bad Request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        /** @description The error code */
                        readonly code?: string
                        /** @description A description of the error */
                        readonly message?: string
                    }
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
        }
    }
    readonly login: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Authentication credentials */
                readonly 'application/json': components['schemas']['LoginRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['LoginResponse']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Authentication Error */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Internal Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
        }
    }
    readonly logout: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Token data */
                readonly 'application/json': components['schemas']['LogoutRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Token not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly maintenanceDb: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MaintenanceDb']
                }
            }
        }
    }
    readonly maintenanceDbBackupDownload: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/gzip': string
                }
            }
            /** @description There is no backup archive file to provide */
            readonly 204: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Locked. There is a database maintenance operation in the process. Try again later. */
            readonly 423: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description File does not exist or download of a backup file failed */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly maintenanceDbBackupStart: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Accepted. Database backup started. */
            readonly 202: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'multipart/form-data': string
                }
            }
            /** @description Locked. There is a database maintenance operation in the process. Try again later. */
            readonly 423: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly maintenanceDbUploadRestore: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                readonly 'multipart/form-data': {
                    /**
                     * Format: binary
                     * @description The backup file
                     */
                    readonly file: string
                }
            }
        }
        readonly responses: {
            /** @description Accepted. The archive is uploaded, and the database restores process starts. */
            readonly 202: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Locked. There is a database maintenance operation in the process. Try again later. */
            readonly 423: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly disableMfa: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description User to disable */
                readonly 'application/json': components['schemas']['MfaDisablePostRequest']
            }
        }
        readonly responses: {
            /** @description ok */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid credentials */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly enableMfa: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description ok */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MfaEnableResponse']
                }
            }
            /** @description User is already enrolled */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly isenrolled: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description ok */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['IsEnrolledResponse']
                }
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly loginMfa: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description All necessary data for logging in with MFA */
                readonly 'application/json': components['schemas']['MfaLoginPostRequest']
            }
        }
        readonly responses: {
            /** @description ok */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MFALoginResponse']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Invalid OTP */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['InvalidOTPResponse']
                }
            }
            /** @description Too many failed login attempts - user is temporarily banned */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['UserBannedResponse']
                }
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['EmptyResponse']
                }
            }
        }
    }
    readonly regenerateBackupcodes: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description User to regenerate codes for */
                readonly 'application/json': components['schemas']['MfaRegeneratePostRequest']
            }
        }
        readonly responses: {
            /** @description ok */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['RegenerateResponse']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid credentials */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly validateEnrollment: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description User to validate */
                readonly 'application/json': components['schemas']['MfaValidatePostRequest']
            }
        }
        readonly responses: {
            /** @description ok */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['MfaValidateResponse']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid OTP */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly msEntraIdLogin: {
        readonly parameters: {
            readonly query?: never
            readonly header?: {
                /** @description See https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Referer. If given, will be used as the redirection in case of internal error during URL generation */
                readonly referer?: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description In case of success or failure, redirects to the URL the client ought to be sent to */
            readonly 302: {
                headers: {
                    /** @description The URL can be:
                     *
                     *     - The MS Entra Login page
                     *     - The referer header (if given)
                     *     - The path where the user is taken to once authentication process is complete
                     */
                    readonly location?: unknown
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description The feature is not enabled. */
            readonly 503: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly msEntraIdRedirect: {
        readonly parameters: {
            readonly query: {
                /** @description The access code provided by MS Entra ID that can be exchanged for Access and ID Tokens. */
                readonly code: string
                /** @description State is a security parameter used to verify that the response is initiated from CW, preventing CSRF attacks. */
                readonly state: string
            }
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description In case of success or failure, redirecting to Admin UI */
            readonly 302: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description The feature is not enabled. */
            readonly 503: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getCurrentUserPermissions: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['Permission'][]
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getPermissionIds: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description The ids of all permissions aggregated by resource, operation and context */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['PermissionIndex'][]
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getPermissionsPage: {
        readonly parameters: {
            readonly query: {
                /** @description Filter by the given permission ids */
                readonly ids?: readonly string[]
                /** @description Set the current page to be retrieved */
                readonly pageNumber: number
                /** @description Set the page size of the yielded page */
                readonly rowsPerPage: number
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Object with array of permissions and pagination information */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly pagination?: components['schemas']['Pagination']
                        readonly permissions?: readonly components['schemas']['PermissionWithUsage'][]
                    }
                }
            }
            /** @description Invalid args provided */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly policyPassword: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['PasswordPolicy']
                }
            }
            /** @description Could not reach server */
            readonly 503: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly policyUsername: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['UsernamePolicy']
                }
            }
            /** @description Could not reach server */
            readonly 503: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly listRoles: {
        readonly parameters: {
            readonly query?: {
                /** @description Filter by equal to name */
                readonly 'name[eq]'?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of roles */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['Role'][]
                }
            }
            /** @description Authentication Error */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Authorization Error */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly createRole: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Role to be created */
                readonly 'application/json': components['schemas']['RolePostRequest']
            }
        }
        readonly responses: {
            /** @description Created */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['Role']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly role: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Role */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['Role']
                }
            }
            /** @description Authentication Error */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Authorization Error */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Role not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly updateRole: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Data required for update of a role */
                readonly 'application/json': components['schemas']['RolePutRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['Role']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Role not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteRole: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Role not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid argument error */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly listRolePermissions: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of permissions */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['Permission'][]
                }
            }
            /** @description Authentication Error */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Authorization Error */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Role not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly createPermission: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Permission to be created */
                readonly 'application/json': components['schemas']['PermissionPostRequest']
            }
        }
        readonly responses: {
            /** @description Created */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Conflict - permission already declared */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getPermission: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
                /** @description Id of permission */
                readonly pemId: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Permission */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['Permission']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description User not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly updatePermission: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
                /** @description Id of permission */
                readonly pemId: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Data required for update of a permission */
                readonly 'application/json': components['schemas']['PermissionPutRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Permission not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deletePermission: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of role */
                readonly id: string
                /** @description Id of permission */
                readonly pemId: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Permission not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly listRoleNames: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Object with array of roles names and ids */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['RoleIndex'][]
                }
            }
            /** @description Authentication Error */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Authorization Error */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly listPaginatesRoles: {
        readonly parameters: {
            readonly query: {
                /** @description Filter by roles that are or not auto generated, defaults to any */
                readonly autoGenerated?: boolean
                /** @description Filter by roles that are or not shared, defaults to any */
                readonly isShared?: boolean
                /** @description Filter by the given names */
                readonly names?: readonly string[]
                /** @description Set the current page to be retrieved */
                readonly pageNumber: number
                /** @description Set the page size of the yielded page */
                readonly rowsPerPage: number
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Object with array of roles and pagination information */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': {
                        readonly pagination?: components['schemas']['Pagination']
                        readonly roles?: readonly components['schemas']['PaginatedRole'][]
                    }
                }
            }
            /** @description Invalid args provided */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
            /** @description Authentication Error */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Authorization Error */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getCurrentUserAuthentication: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['SessionResponse']
                }
            }
            /** @description Unauthorized */
            readonly 401: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Forbidden */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Internal Error */
            readonly 500: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['ErrorResponse']
                }
            }
        }
    }
    readonly createUser: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description User to be created */
                readonly 'application/json': components['schemas']['UserPostRequest']
            }
        }
        readonly responses: {
            /** @description Created */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['User']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly user: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description User */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['User']
                }
            }
            /** @description User not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly updateUser: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Data required for update of a user */
                readonly 'application/json': components['schemas']['UserPutRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['User']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description User not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteUser: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description User not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid argument error */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly createCertificate: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Certificate to be created */
                readonly 'application/json': components['schemas']['CertificatePostRequest']
            }
        }
        readonly responses: {
            /** @description Created */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteUserCertificate: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Data required for deleting a certificate */
                readonly 'application/json': components['schemas']['CertificateDeleteRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Certificate not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly usercreateRole: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Role to be added */
                readonly 'application/json': components['schemas']['UserRolePostRequest']
            }
        }
        readonly responses: {
            /** @description Created */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description User or role not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteUserRole: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Data required for deleting a role */
                readonly 'application/json': components['schemas']['UserRoleDeleteRequest']
            }
        }
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description User or role not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid argument error */
            readonly 409: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly getUserTokens: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description List of user generated tokens */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['Token'][]
                }
            }
            /** @description User not found */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteUserTokens: {
        readonly parameters: {
            readonly query?: {
                /** @description Id of the Token to be deleted. All tokens for the user are deleted if not present. */
                readonly tokenId?: string
            }
            readonly header: {
                readonly Authorization: string
            }
            readonly path: {
                /** @description Id of user */
                readonly id: string
            }
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Token(s) deleted */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Error ocurred when attempting to delete token(s) */
            readonly 404: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly createUsersBatch: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description User to be created */
                readonly 'application/json': readonly components['schemas']['UserPostRequest'][]
            }
        }
        readonly responses: {
            /** @description Created */
            readonly 201: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['NewUserIds']
                }
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly deleteUsersBatch: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description User IDs to be deleted */
                readonly 'application/json': readonly string[]
            }
        }
        readonly responses: {
            /** @description ok */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly changeUserPassword: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody: {
            readonly content: {
                /** @description Credentials */
                readonly 'application/json': components['schemas']['UserChangePasswordRequest']
            }
        }
        readonly responses: {
            /** @description Changed */
            readonly 204: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Invalid request */
            readonly 400: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
            /** @description Unauthorized request */
            readonly 403: {
                headers: {
                    readonly [name: string]: unknown
                }
                content?: never
            }
        }
    }
    readonly listUserIds: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of user ids */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly string[]
                }
            }
        }
    }
    readonly listUsernames: {
        readonly parameters: {
            readonly query?: never
            readonly header: {
                readonly Authorization: string
            }
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description Array of user ids */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': readonly components['schemas']['UserIndex'][]
                }
            }
        }
    }
    readonly envoyTls: {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly requestBody?: never
        readonly responses: {
            /** @description OK */
            readonly 200: {
                headers: {
                    readonly [name: string]: unknown
                }
                content: {
                    readonly 'application/json': components['schemas']['EnvoyGetResponse']
                }
            }
        }
    }
}

/** An auto-generated constant containing all paths */
export const pathsValue = [
    '/api/auth/ldap' as const,
    '/api/auth/mfa' as const,
    '/api/auth/msEntraId' as const,
    '/api/authenticate' as const,
    '/api/authorize' as const,
    '/api/broker/auth/check-updates' as const,
    '/api/broker/auth/enhanced' as const,
    '/api/broker/auth/publish' as const,
    '/api/broker/auth/register' as const,
    '/api/broker/auth/subscribe' as const,
    '/api/broker/auth/subscribeMQTT5' as const,
    '/api/certificates' as const,
    '/api/certificates/content' as const,
    '/api/client-registry' as const,
    '/api/client-registry/confirm' as const,
    '/api/client-registry/lock' as const,
    '/api/client-registry/open' as const,
    '/api/client-registry/register' as const,
    '/api/client-registry/runners/+' as const,
    '/api/client-registry/status' as const,
    '/api/healthz' as const,
    '/api/listUsers' as const,
    '/api/login' as const,
    '/api/logout' as const,
    '/api/maintenance/db' as const,
    '/api/maintenance/db/backup' as const,
    '/api/maintenance/db/restore' as const,
    '/api/mfa/disable' as const,
    '/api/mfa/enable' as const,
    '/api/mfa/isenrolled' as const,
    '/api/mfa/login' as const,
    '/api/mfa/regenerate/backupcodes' as const,
    '/api/mfa/validate' as const,
    '/api/msEntraId/login' as const,
    '/api/msEntraId/redirect' as const,
    '/api/permissions' as const,
    '/api/permissions/ids' as const,
    '/api/permissions/page' as const,
    '/api/policy/password' as const,
    '/api/policy/username' as const,
    '/api/roles' as const,
    '/api/roles/+' as const,
    '/api/roles/+/permissions' as const,
    '/api/roles/+/permissions/+' as const,
    '/api/roles/names' as const,
    '/api/roles/page' as const,
    '/api/session' as const,
    '/api/users' as const,
    '/api/users/+' as const,
    '/api/users/+/certificates' as const,
    '/api/users/+/roles' as const,
    '/api/users/+/tokens' as const,
    '/api/users/batch' as const,
    '/api/users/batch/delete' as const,
    '/api/users/change-password' as const,
    '/api/users/ids' as const,
    '/api/users/usernames' as const,
    '/api/v1/certs/list/approved' as const,
]
